/**
 * Naming convention:
 * {category, ui element}_{what_it_does}_{what_it_does}
 *
 * examples:
 * icon_youtube
 * language_selector_dropdown_label
 * color_theme_brown_dark
 * background_color_brown_dark
 * text_color_brown_dark
 */
export const TAXONOMIES_MAP = {
  link_collection: {
    navigation_main: "navigation_main",
    navigation_footer: "navigation_footer",
    navigation_social_inks: "navigation_social_links",
  },
  layout: {
    layout_spacing_none: "layout_spacing_none", // 0px
    layout_spacing_sm: "layout_spacing_sm", // 40px
    layout_spacing_md: "layout_spacing_md", // 80px
    layout_spacing_lg: "layout_spacing_lg", // 120px
    layout_white_top_separator: "layout_white_top_separator",
  },
  container_module: {
    grid_6_columns: "grid_6_columns",
    grid_4_columns: "grid_4_columns",
    grid_3_columns: "grid_3_columns",
  },
  general: {
    red_hop_leaf: "module_red_hop_leaf",
    green_hop_leaf: "module_green_hop_leaf",
    show_as_story_hero: "show_as_story_hero",
  },
  event_module: {
    eventcard_custom: "eventcard_custom",
    eventcard_cancelled: "eventcard_cancelled",
  },
  cardlist_module: {
    cardlist_module_textcard: "gb_list_layout_3",
  },
  hero_module: {
    hide_scroll_down: "hide_scroll_down",
  },
  table_module: {
    table_module_light_layout: "table_module_light_layout",
    table_module_stack_on_mobile: "table_module_stack_on_mobile",
  },
  page: {
    page_show_book_ticket_mobile: "page_show_book_ticket_mobile",
    page_hide_book_ticket_desktop: "page_hide_book_ticket_desktop",
  },
  map_module: {
    ratio_1_1: "map_module_ratio_1_1",
  },
  blockquote: {
    blockquote_special_layout: "blockquote_special_layout",
  },
  text_module: {
    text_module_as_faq_hero: "text_module_as_faq_hero",
  },
  media_module: {
    bottle_collection: "bottle_collection",
  },
};
